import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-dlg-alert',
    templateUrl: './dlg-alert.component.pug',
    styleUrls: ['./dlg-alert.component.less'],
})
export class DlgAlertComponent implements OnInit {

    constructor(
        public dialogRef: MatDialogRef<DlgAlertComponent>,

        @Inject(MAT_DIALOG_DATA) public data: any
    ) { }

    ngOnInit() {
    }

    onContinue() {
        this.dialogRef.close(true);
    }

    onCancel() {
        this.dialogRef.close(false);
    }

    onClose() {
        this.dialogRef.close();
    }

}
